<template>
  <div class="ba-w-100 ba-flex ba-gp-1 ba-f-column" id="conteudo-para-pdf">
    <div class="ba-flex ba-logo" id="ba-logo">
      <img src="/internacional/public/office3/img/menu-bar/logo.svg">
    </div>

    <div class="ba-flex ba-jc-sb ba-ai-center header">
      <div class="header-title">
        <span class="ba-montserrat-600">{{ t.evalute_your_page }}</span>
        <div class="underline"/>
      </div>
    </div>

    <div class="box-outline ba-w-100 ba-flex ba-ai-center ba-jc-sb ba-mg-b-2">
      <div class='ba-box-search-input'>
        <input type='search' class='ba-input' placeholder='keyword' v-model="param_keyword" />
      </div>

      <div class='ba-box-search-input w-47'>
        <input type='search' class='ba-input' placeholder='URL' v-model="param_url" @keypress="handleEnterKey" />
      </div>

      <button class='ba-btn ba-lg ba-blue text-capitalize'
              @click="sendToAnalize()">
        {{ t.new_seo_report }}
      </button>
    </div>


    <builderall-loader :loading="loading">
      <div v-if="loading == false && totalKeywords != null || loading == true"
           class="ba-flex ba-gp-1 ba-f-column"
           :style="loading ? 'padding: 2rem;' : ''"
      >
        <div class="ba-flex ba-jc-sb ba-ai-center header content_title">
          <div class="header-title">
            <span class="ba-montserrat-600">{{ t.label_total_sites }}</span>
            <div class="underline"/>
          </div>

          <button class='ba-btn ba-lg ba-blue text-capitalize' @click="generatePDF">
            {{ t.save }} PDF
          </button>
        </div>

        <div class="ba-flex ba-jc-sb ba-ai-center">
          <div class="ba-btn ba-lg widget"
               v-for="(val, keyword) in totalKeywords"
               :key="keyword"
               :class="[val == 0 ? 'ba-light' : 'ba-blue']"
               v-text="`${val} ${keyword}`"
          />
        </div>

        <div class="box-outline ba-w-100 ba-flex ba-ai-center ba-jc-sb ba-mg-b-2">
          <div class="ba-w-50 ba-flex ba-f-column ba-ai-center ba-gp-1 ba-jc-se">
            <H3 class="ba-montserrat-600 ba-color-dark5 ba-mg-b-2">{{ t.tool_seo_nota_title.replace('{note}', notaPage) }}</H3>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.11 5.5626L11.136 16.5366C10.9608 16.7124 10.7304 16.8 10.5 16.8C10.2696 16.8 10.0392 16.7124 9.8634 16.5366L6.8634 13.5366C6.5118 13.185 6.5118 12.6156 6.8634 12.264C7.215 11.9124 7.7844 11.9124 8.136 12.264L10.4994 14.6274L21.0174 4.1094C18.8166 1.5966 15.5946 0 12 0C5.3832 0 0 5.3832 0 12C0 18.6168 5.3832 24 12 24C18.6168 24 24 18.6168 24 12C24 9.6306 23.3004 7.425 22.11 5.5626Z" fill="#1AD9A9"/>
            </svg>
            <span class="ba-color-dark5">{{ t.tool_seo_nota_desc }}</span>
          </div>

          <div class="ba-card w-40">
            <div class="ba-flex ba-jc-sb ba-ai-center header ba-w-100">
              <div class="header-title">
                <span class="ba-montserrat-600">{{ t.jt_foxx_sites }}</span>
                <div class="underline"/>
              </div>
            </div>

            <div class="ba-btn ba-lg widget ba-w-100 ba-light ba-montserrat-600 text-14 ba-color-dark5">{{ t.btn_overview_title }}</div>

            <div class="ba-flex ba-jc-sb ba-ai-center header overview ba-w-100 cursor-pointer"
                 v-for="(fator, i) in fatores"
                 :key="i"
                 @click="scrollToSection(i)"
            >
              <span class="ba-montserrat-600 text-14 ba-color-dark5">{{ fator.title }}</span>

              <div class="factor-counter text-14 ba-color-dark5"
                   :class="{ 'complete' : fator.count_factor.count === fator.count_factor.total }"
              >{{ `${fator.count_factor.count} / ${fator.count_factor.total}` }}</div>
            </div>
          </div>
        </div>

        <div class="ba-flex ba-jc-sb ba-ai-center header">
          <div class="header-title">
            <span class="ba-montserrat-600">{{ t.tool_seo_detalhes }}</span>
            <div class="underline"/>
          </div>
        </div>


        <div v-for="(fator, i) in fatores"
             :key="i"
        >
          <div class="ba-btn ba-lg widget ba-w-100 ba-light ba-montserrat-600 widget-title" :id="i">
            <span>{{ fator.title }}</span>
            <div class="factor-counter text-14 ba-color-dark5"
                 :class="{ 'complete' : fator.count_factor.count === fator.count_factor.total }"
            >{{ `${fator.count_factor.count} / ${fator.count_factor.total}` }}</div>
          </div>

          <div class="factors"
               v-for="(factor, a) in fator.factors"
               :key="a"
          >
            <div class="ba-flex ba-jc-sb ba-ai-center factor-title cursor-pointer"
                 @click="expandCollapse(`factor-${i}-${a}`)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path class="factor-error" :class="{ 'true': factor.error }" d="M14.74 3.7084L7.424 11.0244C7.3072 11.1416 7.1536 11.2 7 11.2C6.8464 11.2 6.6928 11.1416 6.5756 11.0244L4.5756 9.0244C4.3412 8.79 4.3412 8.4104 4.5756 8.176C4.81 7.9416 5.1896 7.9416 5.424 8.176L6.9996 9.7516L14.0116 2.7396C12.5444 1.0644 10.3964 0 8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 6.4204 15.5336 4.95 14.74 3.7084Z"/>
              </svg>
              <span class="text-14 ba-color-dark5 ba-montserrat-600">{{ factor.title }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M15.3901 6.31844C15.2324 6.31845 15.0762 6.34954 14.9305 6.40994C14.7849 6.47034 14.6525 6.55886 14.5411 6.67044L10.2961 10.9144L6.05208 6.67044C5.94046 6.55882 5.80794 6.47027 5.6621 6.40986C5.51626 6.34945 5.35994 6.31836 5.20208 6.31836C4.88327 6.31836 4.57752 6.44501 4.35208 6.67044C4.24046 6.78206 4.15191 6.91458 4.0915 7.06042C4.03109 7.20627 4 7.36258 4 7.52044C4 7.83925 4.12665 8.14501 4.35208 8.37044L9.44508 13.4604C9.55657 13.5723 9.68904 13.6611 9.8349 13.7216C9.98076 13.7822 10.1371 13.8134 10.2951 13.8134C10.453 13.8134 10.6094 13.7822 10.7553 13.7216C10.9011 13.6611 11.0336 13.5723 11.1451 13.4604L16.2391 8.36744C16.4071 8.19961 16.5215 7.98571 16.5679 7.75281C16.6143 7.51991 16.5905 7.27848 16.4996 7.05909C16.4087 6.8397 16.2548 6.65222 16.0573 6.52038C15.8597 6.38853 15.6276 6.31825 15.3901 6.31844Z" fill="#8D9EB5"/>
              </svg>
            </div>

            <div class="factor-description box-outline white js-d-none"
                 :id="`factor-${i}-${a}`"
            >
              <div class="ba-flex ba-f-column ba-gp-04">
                <span class="ba-montserrat-700 ba-color-dark3 text-14">{{ factor.resp_title }}</span>
                <span class="ba-montserrat-500 ba-color-dark3 text-14"
                      v-for="(rc, j) in factor.resp_content"
                      :key="j"
                >
              {{ `${rc.title}${rc.res}` }}
            </span>
              </div>
              <div class="separator" />
              <div class="ba-flex ba-f-column ba-gp-04">
                <span class="ba-montserrat-700 ba-color-dark3 text-14">{{ t.tool_seo_explanation }}</span>
                <span class="ba-montserrat-500 ba-color-dark3 text-14">{{ factor.Explanation }}</span>
              </div>
              <div class="separator" v-if="factor.error"/>
              <div class="ba-flex ba-f-column ba-gp-04"
                   v-if="factor.error"
              >
                <span class="ba-montserrat-700 ba-color-dark3 text-14">{{ t.tool_seo_recommendation }}</span>
                <span class="ba-montserrat-500 ba-color-dark3 text-14">{{ factor.Recommendation }}</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </builderall-loader>

  </div>
</template>

<script>
export default {
  name: "seo-report",
  props: ["view"],
  data() {
    return {
      t: null,
      param_keyword: '',
      param_url: '',
      totalKeywords: null,
      notaPage: null,
      fatores: null,
      loading: false
    }
  },
  created() {
    this.t = this.view.translation
  },
  mounted() {
    $('#ba-logo').hide()
  },
  methods: {
    sendToAnalize() {
      this.loading = true
      var vm = this,
        bodyForm = new FormData();

      bodyForm.append('param_keyword', this.param_keyword)
      bodyForm.append('param_url', this.param_url)

      axios.post(this.view.handler_routes.rota_office_generic_ferramenta_seo, bodyForm)
        .then(response => {
          vm.totalKeywords = response.data.data.total_keywords
          vm.notaPage = response.data.data.nota_page
          vm.fatores = response.data.data.fatores
        })
        .catch(error => {
          console.error('error', error)
        })
        .finally(() => {
            vm.loading = false
        })
    },
    scrollToSection(section) {
      const targetSection = document.getElementById(section);

      if (targetSection) {
        targetSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    handleEnterKey(event) {
      if (event.key === 'Enter') {
        this.sendToAnalize()
      }
    },
    expandCollapse(id) {
      if($(`#${id}`).hasClass('js-d-none')){
        $(`#${id}`).removeClass('js-d-none')
        $(`#${id}`).addClass('js-show')
      } else {
        $(`#${id}`).removeClass('js-show')
        setTimeout(() => {
          $(`#${id}`).addClass('js-d-none')
        },420);
      }
    },
    async generatePDF() {
      await this.expandAllCollapses()
      $('#ba-logo').show()

      var content = document.querySelector("#conteudo-para-pdf")

      var options = {
        margin: [0, 0, 0, 0],
        filename: 'report-seo.pdf',
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }
      }

      html2pdf().set(options).from(content).save()

      setTimeout(() => {
        this.colseAllColapses
        $('#ba-logo').hide()
      },10000);
    },
    expandAllCollapses() {
      var elementosComClasse = $(".js-d-none")
      elementosComClasse.removeClass("js-d-none").addClass("js-show")
    },
    colseAllColapses() {
      var elementosComClasse = $(".js-show")
      elementosComClasse.removeClass("js-show").addClass("js-d-none")
    }
  }
}
</script>

<style scoped lang="scss">
.content_title {
  .header-title {
    width: 86% !important;
  }
}
.overview {
  position: relative;
}
.overview::before {
  position: absolute;
  content: '';
  margin-top: 40px;
  width: 100%;
  background-color: #C4D1E0;
  height: 1px;
}
.factors {
  margin: 6px 20px;
  position: relative;

  .factor-title {
    height: 40px;
  }
  .factor-description {
    overflow: hidden;
    transition: max-height .7s;
    max-height: 0;

    &.js-show {
      height: auto;
      max-height: 20rem;
    }
    &.js-d-none {
      display: none;
    }
  }
  .separator {
    margin: 16px 0;
    width: 100%;
    background-color: #C4D1E0;
    height: 1px;
  }
}
.factors::after {
  position: absolute;
  bottom: -7px;
  content: '';
  width: 100%;
  background-color: #C4D1E0;
  height: 1px;
}
.header {
  height: 36.58px;

  .header-title {
    width: 100%;

    span {
      font-size: 14px;
      line-height: 16.5px;
      color: #4D5D71;
    }
  }
}
.box-outline {
  border-radius: 4px;
  border: 1px solid #D9D9D9;
  padding: 20px 8px;
  background: rgba(217, 217, 217, 0.10);

  &.white {
    background: #FFFFFF;
  }
  .w-47 {
    width: 47%;
  }
}
.underline {
  margin-top: 9px;
  width: 100%;
  background-color: #C4D1E0;
  height: 1px;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.widget {
  margin: 0 !important;
  cursor: default !important;
}
.widget:hover {
  box-shadow: none !important;
}
.widget-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.w-40 {
  width: 40%;
}
.factor-counter {
  padding: 5px 10px;
  border-radius: 4px;
  background: #EFF2F8;

  &.complete {
    background: #01D4B9;
  }
}
.text-14 {
  font-size: 14px;
  line-height: 16.5px;
}
.factor-error {
  fill: #1AD9A9;

  &.true {
    fill: rgba(149, 172, 204, 0.40);;
  }
}

.self-building-square-spinner, .self-building-square-spinner * {
  box-sizing: border-box;
}

.self-building-square-spinner {
  height: 40px;
  width: 40px;
  top: calc( -10px * 2 / 3);
}

.self-building-square-spinner .square {
  height: 10px;
  width: 10px;
  top: calc( -10px * 2 / 3);
  margin-right: calc(10px / 3);
  margin-top: calc(10px / 3);
  background: #0080fc;
  float: left;
  position:relative;
  opacity: 0;
  animation: self-building-square-spinner 6s infinite;
}

.self-building-square-spinner .square:nth-child(1) {
  animation-delay: calc(300ms * 6);
}

.self-building-square-spinner .square:nth-child(2) {
  animation-delay: calc(300ms * 7);
}

.self-building-square-spinner .square:nth-child(3) {
  animation-delay: calc(300ms * 8);
}

.self-building-square-spinner .square:nth-child(4) {
  animation-delay: calc(300ms * 3);
}

.self-building-square-spinner .square:nth-child(5) {
  animation-delay: calc(300ms * 4);
}

.self-building-square-spinner .square:nth-child(6) {
  animation-delay: calc(300ms * 5);
}

.self-building-square-spinner .square:nth-child(7) {
  animation-delay: calc(300ms * 0);
}

.self-building-square-spinner .square:nth-child(8) {
  animation-delay: calc(300ms * 1);
}

.self-building-square-spinner .square:nth-child(9) {
  animation-delay: calc(300ms * 2);
}

.self-building-square-spinner .clear{
  clear: both;
}

@keyframes self-building-square-spinner {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 1;
    top: 0;
  }
  50.9% {
    opacity: 1;
    top: 0;
  }
  55.9% {
    opacity: 0;
    top: inherit;
  }
}
.ba-logo {
  justify-content: flex-start;
  margin: .5rem 0;
  img {
    height: 3rem;
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/seo-report/SeoReport.vue